import React from "react";
import { Link as GatsbyLink } from "gatsby";
import {
  Box,
  Text,
  Center,
  Link
  } from '@chakra-ui/react'
import styled from '@emotion/styled';

const Icon = styled(Box)`
display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
    cursor: pointer;
    > p {
        color: #70A37F;
    }
    > div > svg {
        fill: #70A37F;
    }

    &:hover {
        > p {
            color: #40634A;
        }
        > div > svg {
            fill: #40634A;
        }
    }
`

const Map = (props) => {
  return (
    <Icon as={GatsbyLink} to="/discover/maps-travel-info#maps" _hover={{textDecoration: 'none'}}>
      <Center w="25%" mx="auto">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 34.947 46.596">
    <path id="map-marker-alt-solid" d="M15.678,45.656C2.454,26.486,0,24.519,0,17.473a17.473,17.473,0,1,1,34.947,0c0,7.045-2.454,9.013-15.678,28.182a2.185,2.185,0,0,1-3.592,0Zm1.8-20.9a7.281,7.281,0,1,0-7.281-7.281A7.281,7.281,0,0,0,17.473,24.754Z" />
  </svg>
   </Center>
   <Text textAlign="center" fontSize={{base: 'xs', md: 'sm'}} className="menu-bar">
        Maps
    </Text>
   </Icon>
  );
};

export default Map;